// extracted by mini-css-extract-plugin
export default {"columnNarrow":"rates_table_header_columnNarrow__hlNJ9","tableHeaderWrapper":"rates_table_header_tableHeaderWrapper__W2Osi"};